import { useSiteContent } from '@/context/SiteContentContext';
import { useTheme } from '@/context/ThemeContext';

export default function FeatureStrip() {
  const { content } = useSiteContent();
  const { features } = content;
  const { theme } = useTheme();
  const light = theme === 'light';

  return (
    <section className={`w-full transition-colors duration-300 ${light ? 'bg-gray-100 border-b border-gray-200' : 'bg-[#1C2B3A]'}`}>
      <div className="w-full px-6 md:px-10 py-8">
        <div className={`grid grid-cols-2 lg:grid-cols-4 gap-0 divide-x ${light ? 'divide-gray-300' : 'divide-white/10'}`}>
          {features.map((f, i) => (
            <div key={i} className="flex items-center gap-4 px-6 py-4 first:pl-0 last:pr-0">
              <div className="w-10 h-10 flex items-center justify-center shrink-0">
                <i className={`${f.icon} text-2xl`} style={{ color: 'var(--accent)' }}></i>
              </div>
              <div>
                <p className={`font-bold text-sm tracking-wide ${light ? 'text-gray-900' : 'text-white'}`}>{f.title}</p>
                <p className={`text-xs mt-0.5 ${light ? 'text-gray-500' : 'text-white/50'}`}>{f.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
